import React from 'react';

export const LevelBadge = ({ level }) => (
  <span className={`inline-block px-1.5 py-0.5 text-[10px] rounded-full font-semibold ${
    level === 'Light' ? 'bg-yellow-100 text-yellow-800' :
    level === 'Dark' ? 'bg-stone-700 text-white' : 'bg-amber-100 text-amber-800'
  }`}>{level}</span>
);

export const PayBadge = ({ status }) => (
  <span className={`inline-block px-2 py-0.5 text-[10px] rounded-full font-semibold ${
    status === 'Paid' ? 'bg-emerald-100 text-emerald-800' :
    status === 'Partial' ? 'bg-amber-100 text-amber-800' : 'bg-rose-100 text-rose-700'
  }`}>{status || 'Unpaid'}</span>
);
